import { render } from "./showDocument.vue?vue&type=template&id=3829a62c&scoped=true"
import script from "./showDocument.vue?vue&type=script&lang=js"
export * from "./showDocument.vue?vue&type=script&lang=js"

import "./showDocument.vue?vue&type=style&index=0&id=3829a62c&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3829a62c"]])

export default __exports__